// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum ProductType {
  M2000 = 0,
  M3000 = 1,
  M4000 = 2,
  ICue = 3,
  ICueImp = 4,
  Dispatcher = 5,
}
